import { WsApi } from "@/utils/http-client";

export default {
  getInvoice(transactionId) {
    return WsApi.get("/api/paymentflow/v1/guestpayment", { transactionId });
  },
  validateInvoice(invoiceNumber, transactionId) {
    return WsApi.get(`/api/paymentflow/v1/invoices/validate`, { transactionId, invoiceNumber });
  },
  generateTransactionId(payload) {
    return WsApi.post("/api/paymentflow/v1/transaction/generate", payload);
  },
};
